module.exports = __webpack_public_path__ + "img/account_mb_04.a28bb59c.jpg";